// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: "https://localhost:5001",
  //apiUrl: "http://3.221.121.109:8082",
  apiUrl: "https://3reyes-back.shipandtrace.tech",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone r//elated error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
